import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { DockerImageDto, ListDockerImagesQueryRequest } from 'dto/raptor-docker-image.dto';
import { transform } from 'dto/transformer';

export class RaptorDockerImagesApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('raptorDockerImages', options);
    }

    protected getRootPath(): string {
        return 'raptor/docker-images';
    }

    public async listDockerImages(accountId: number, query: ListDockerImagesQueryRequest): Promise<DockerImageDto[]> {
        const response = await this.send<{ dockerImages: DockerImageDto[] }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId, '', this._convertToValidQuery(query)),
        );
        return transform(DockerImageDto, response.dockerImages);
    }
}
